<div class="blotter_table_target" #tableTarget>
  <ag-grid-angular
    style="width: 100%; height: 100%"
    class="ag-bcdfx pinned-border"
    [columnDefs]="columnDefs"
    [gridOptions]="gridOptions"
    [toolPanelSuppressSideButtons]="true"
    enableColResize
    enableSorting
    rowHeight="22"
    multiSortKey="ctrl"
    (mouseup)="onMouseUp($event)"
    (contextmenu)="handleClick($event)"
  >
  </ag-grid-angular>
</div>
<bfx-blotter-column-selector [currentLadderBlotter]="blotterInstance" bfxElementOnBody>
</bfx-blotter-column-selector>
